<template>
    <Layout>
    <div class="row align-items-center">
        <div class="d-flex align-items-center mb-4">
          <router-link :to="`/reconciliation`">
            <h4 class="m-0">{{ $t("billing_invoices.custom.recons_detail") }}</h4>
          </router-link>
          <div class="mx-2">\</div>
          <div>
            {{
              $i18n.locale == "ar"
                ? "تفاصيل " + ' - ' + `${this.year}/${this.month}` 
                : " Details" +' - ' +  `${this.year}/${this.month}` 
            }}
          </div>
        </div>
      </div>
      <div></div>
      <div class="row my-4">
            <div class="col-6">
                <div>
                    <div class="search-box chat-search-box w-50">
                        <div class="position-relative">
                            <input type="text" class="form-control fa-lg text-light" :placeholder="$t('billing_invoices.recons.search')" v-model="search"
                              style="
                                background-color: #2a3042 !important;
                                width: 250px !important;
                              " />
                            <i class="bx bx-search-alt search-icon text-light"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row g-3">
            <div class="col-12">
                <div class="table-responsive">
                    <table class="table">
                        <thead :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'" class="table table-centered table-nowrap table-striped table-hover align-middle">
                            <tr class="text-light" style="background-color: #2a3042 !important">
                                <th scop="col">#</th>
                                <th scop="col">{{ $t('billing_invoices.custom.name') }}</th>
                                <th scop="col">{{ $t('billing_invoices.custom.branch') }}</th>
                                <th scop="col">{{ $t('billing_invoices.custom.account') }}</th>
                                <th scop="col">{{ $t('billing_invoices.custom.paidamount') }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, indx) in customers" :key=indx>
                                <td>{{ ((currentPage - 1) * perPage) + indx + 1 }}</td>
                                <td>{{ item.name }}</td>
                                <td>{{ item.branch_id === 1 ? 'KASSALA' : 'GIRBA' }}</td>
                                <td>{{ item.account_no }}</td>
                                <td>{{ parseFloat(item.value).toLocaleString() }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="d-flex justify-content-center">
            <BPagination :total-rows="rows" :per-page="perPage" v-model="currentPage"/>
        </div>
    </Layout>
</template>
<script>
import Layout from "../../../layouts/main.vue";
export default {
    components: {Layout},
    data() {
        return{
            perPage: 10,
            currentPage: 1,
            rows: 0,
            search: '',
            customers: [],
        }
    },
    watch: {
        search() {
            if (this.search.length > 0)
                this.GetCustomers()
            else
                this.currentPage = 1
        },
        currentPage() {
            this.GetCustomers()
        }
    },
    methods: {
        GetCustomers() {
            this.http.post('billing-invoices/customers', {page: this.currentPage, limit: this.perPage, query: this.search, recons_id: this.$route.params.id}).then((res) => {
                this.customers = res.data
                const date = res.data[0]
                this.month = date.month
                this.year = date.year
                this.rows = res.tot
            })
        },
    },
    mounted() {
        this.GetCustomers()
    }
    
}
</script>
<style lang="">
    
</style>